module.exports = __webpack_public_path__ + "static/img/200099.28d4a363.png";